/** AdminTab — composes admin sections; gated by is_admin capability. */

import { useAuth } from '../../../contexts/AuthContext';
import CurrentUserSection from './CurrentUserSection';
import ObservabilitySection from './ObservabilitySection';

export default function AdminTab() {
  const { capabilities } = useAuth();

  if (!capabilities?.is_admin) {
    return (
      <div className="flex flex-col items-center gap-2 py-16 text-center">
        <h2 className="text-lg font-semibold text-foreground">Access denied</h2>
        <p className="text-sm text-muted-foreground">Admin privileges required.</p>
      </div>
    );
  }

  return (
    <main className="mx-auto flex w-full max-w-160 flex-col gap-2">
      <CurrentUserSection />
      <ObservabilitySection />
    </main>
  );
}
